export const MS_IN_SEC = 1000;

export const getSecondsSinceEpoch = (): number => Math.round(Date.now() / MS_IN_SEC);
